import React from 'react';
import {useRouter} from 'next/router';

import DocumentHeader from '../../components/DocumentHeader';
import ReferralRequestForm from './ReferralRequestForm';
import Waitlist from './Waitlist';
import {useAppContext} from '../../hooks';

const REFERRAL_FEATURE = 'referrals_navigation';

export default function JobReferralsNewReferralPage({company}) {
  const {features} = useAppContext();
  const router = useRouter();

  const canBeReferred = features[REFERRAL_FEATURE] === 'on';

  return (
    <div className="mx-auto max-w-6xl px-4 pt-6 pb-20">
      <DocumentHeader
        title="Submit a Referral Request"
        socialDescription="Request referrals from employees at top tech companies like Google, Facebook, Amazon, and more."
        imgPath="https://static.tryexponent.com/job_referrals_thumbnail_3464d8b8e2.png"
      />

      {canBeReferred ? (
        <ReferralRequestForm
          company={company}
          isLayoff={router.pathname.includes('layoffs')}
        />
      ) : (
        <Waitlist />
      )}
    </div>
  );
}
